import React from 'react'
import {Text, View } from '@react-pdf/renderer'
import styles from './styles'

function fixedView(style) {
  return ({children}) => (<View style={style} fixed>{children}</View>)
}

export function Title (props) {
  return (
    <View style={[styles.title, ...(props.styles || [])]} wrap={false}>
      <Text>{props.title}</Text>
    </View>
  )
}

export function LabeledInfo (props) {
  return (
    <View style={[styles.labeledInfo, ...(props.styles || [])]} wrap={false}>
      {props.label && <Text style={styles.labeledInfoLabel}>{props.label}:</Text>}
      <View style={styles.labeledInfoContent}>{props.children}</View>
    </View>
  )
}

export const Header = fixedView(styles.header)
export const Footer = fixedView(styles.footer)
